import { updatesData } from '@/mocks/homeData';

const tagColors: Record<string, string> = {
  '更新': 'bg-accent-500',
  '完结': 'bg-primary-500',
};

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="mb-8 md:mb-10">
          <span className="text-xs font-semibold text-accent-500 uppercase tracking-wider">⚡ LIVE UPDATES</span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mt-2">更新动态</h2>
          <p className="text-sm text-foreground-500 mt-1">实时追踪热门漫画更新，不错过任何一话精彩内容</p>
        </div>

        <div className="relative">
          <div className="absolute left-[15px] top-0 bottom-0 w-px bg-background-300"></div>
          <div className="flex flex-col gap-0">
            {updatesData.map((item, idx) => (
              <a
                key={idx}
                href="#"
                className="relative flex items-start gap-5 py-4 pl-10 pr-4 hover:bg-background-50/60 rounded-xl transition-colors duration-200 cursor-pointer no-underline group"
              >
                <div className={`absolute left-[7px] top-[22px] w-[17px] h-[17px] rounded-full border-[3px] border-background-100 ${
                  item.tag === '完结' ? 'bg-primary-500' : 'bg-accent-500'
                }`}></div>

                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1 flex-wrap">
                    <span className={`px-1.5 py-0.5 text-[10px] font-bold text-background-50 rounded ${tagColors[item.tag] || 'bg-accent-500'} flex-shrink-0`}>
                      {item.tag}
                    </span>
                    <span className="text-xs text-foreground-400 flex-shrink-0">{item.time}</span>
                  </div>
                  <h3 className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors">{item.title}</h3>
                  <p className="text-xs md:text-sm text-foreground-500 mt-1 leading-relaxed">{item.desc}</p>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}